import i from"react";var t=({element:e})=>i.createElement(i.Fragment,null,e?.icon&&i.createElement("div",{className:e?.showMobile!==!0?"hidden md:inline":""},e?.icon),i.createElement("div",null,e?.value));export{t as a};
